var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        position: "relative",
        display: "flex",
        "justify-content": "flex-start"
      }
    },
    [
      _vm.alwaysShow || _vm.currentState !== _vm.states.hidePop
        ? [
            _c("div", [_c("span", [_vm._v(" " + _vm._s(_vm.lbSize.text))])]),
            _vm._l(_vm.exchangeAmount.dataProvider, function(item, index) {
              return _c(
                "div",
                { key: index },
                [_c("charge-count-item-renderer", { attrs: { item: item } })],
                1
              )
            })
          ]
        : _vm._e(),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDetail,
              expression: "showDetail"
            }
          ],
          staticStyle: {
            color: "deepskyblue",
            cursor: "pointer",
            "padding-left": "5px"
          },
          on: {
            click: function($event) {
              return _vm.chargeCountGroupHP.clickHandler($event)
            }
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_AmountToDetail")) + " "),
          _c("i", {
            class:
              _vm.currentState === _vm.states.hidePop
                ? "el-icon-caret-bottom"
                : "el-icon-caret-top"
          })
        ]
      ),
      _c("cargo-ag-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDetail && _vm.currentState === _vm.states.dispPop,
            expression: "showDetail && currentState===states.dispPop"
          }
        ],
        style: _vm.detailGridStyle,
        attrs: {
          "show-side-bar": false,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }